module.exports = __webpack_public_path__ + "static/media/handle3.58120bac.png";